import { ProvidersType } from 'modules/SlotsRoot/types/configuration'

export const uniqGameIdSeparator = '__'

export const uniqGameId = (integration: ProvidersType, provider: string, gameId: string): string =>
  `in:${integration}${uniqGameIdSeparator}pr:${provider}${uniqGameIdSeparator}id:${gameId}`

export const getPureGameId = (gameId: string) => /id:(.*)/.exec(gameId)?.[1] ?? gameId
